let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bxTaA")).then(() => parcelRequire('cg8m4'));